import type { CSSProperties } from 'react'

export const MOBILE_SINGLE_COLUMN = 'minmax(0, 1fr)'

export const MOBILE_FULL_WIDTH_BUTTON_STYLE: CSSProperties = {
  width: '100%',
  justifyContent: 'center',
  whiteSpace: 'normal',
  textAlign: 'center',
  minWidth: 0,
}

export const TEXT_WRAP_STYLE: CSSProperties = {
  minWidth: 0,
  overflowWrap: 'anywhere',
}

export function mobileButtonStyle(isMobile: boolean): CSSProperties | undefined {
  return isMobile ? MOBILE_FULL_WIDTH_BUTTON_STYLE : undefined
}

export function gridColumns(isMobile: boolean, desktopColumns: string, mobileColumns = MOBILE_SINGLE_COLUMN): string {
  return isMobile ? mobileColumns : desktopColumns
}
